import { useState } from 'react';
import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const [imgError, setImgError] = useState(false);

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-6">
              <i className="ri-sparkling-2-line text-sm"></i>
              <span>{heroData.tag}</span>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              {heroData.title}
            </h1>

            <p className="text-base md:text-lg text-primary-600 font-heading font-medium mb-6 italic">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl lg:max-w-none mb-8">
              {heroData.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {heroData.stats.map((stat, idx) => (
                <div key={idx} className="text-center lg:text-left">
                  <div className="font-heading text-xl md:text-2xl font-bold text-primary-500">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                {heroData.primaryCta.label}
              </a>
              <a
                href={heroData.secondaryCta.href}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                {heroData.secondaryCta.label}
              </a>
            </div>
          </div>

          {!imgError && (
            <div className="flex-1 w-full max-w-lg lg:max-w-none">
              <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden">
                <img
                  src={heroData.image}
                  alt="8090影院经典电影怀旧氛围"
                  className="w-full h-full object-cover"
                  onError={() => setImgError(true)}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}